import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'AwarenessCenter/WizardTrainingCampaign/MessageStep'

export const GET_EMAIL_PREVIEW_ASYNC = createAsyncTypes('GET_EMAIL_PREVIEW', typeKey)
export const DATA_HAS_CHANGED = `${typeKey}/DATA_HAS_CHANGED`
